// extracted by mini-css-extract-plugin
export default {"card-value":"CardValue_card-value__uW5iC","card-value__content":"CardValue_card-value__content__DRhqd"};